import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './par-type-kafalat.reducer'; // Changer le chemin ici
import { IParTypeKafalat } from 'app/shared/model/par-type-kafalat.model'; // Changer le modèle ici
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParTypeKafalat = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const parTypeKafalatList = useAppSelector(state => state.parTypeKafalat.entities);
  const loading = useAppSelector(state => state.parTypeKafalat.loading);

  // eslint-disable-next-line no-console
  console.log('parTypeKafalatList:', parTypeKafalatList);

  useEffect(() => {
    dispatch(getEntities({}));
    // eslint-disable-next-line no-console
    console.log('heeeey');
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="par-type-kafalat-heading" data-cy="ParTypeKafalatHeading">
        <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.home.title">Par Type Kafalat</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.home.createLabel">Create new Par Type Kafalat</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {parTypeKafalatList && parTypeKafalatList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.nameAr">Name ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.nameEn">Name en</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {parTypeKafalatList.map((parTypeKafalat, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${parTypeKafalat.id}`} color="link" size="sm">
                      {parTypeKafalat.id}
                    </Button>
                  </td>
                  <td>{parTypeKafalat.code}</td>
                  <td>{parTypeKafalat.name}</td>
                  <td>{parTypeKafalat.nameAr}</td>
                  <td>{parTypeKafalat.nameEn}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${parTypeKafalat.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${parTypeKafalat.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${parTypeKafalat.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${parTypeKafalat.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.parTypeKafalat.home.notFound">No Par Type Kafalat found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ParTypeKafalat;
